module.exports = __webpack_public_path__ + "static/media/icon_evidence_shadowed.3ace8731.svg";


//////////////////
// WEBPACK FOOTER
// ./client/modules/ui/assets/icon_evidence_shadowed.svg
// module id = 1251
// module chunks = 0